import { useUserStore } from '@/store';
import { objectRoleEnum } from '@/utils/const';

export default function usePermission() {
  const userStore = useUserStore();
  return {
    accessRouter(route) {
      return !route.meta?.requiresAuth || userStore.userInfo?.roles?.find((el) => el == route.meta?.roles) || !route.meta?.roles;
    },
    findFirstPermissionRoute(_routers, role, menu) {
      const cloneRouters = [..._routers];
      let menuSort = null;
      if (menu?.length) {
        const firstRole = role?.[0];
        for (let index = 0; index < menu.length; index++) {
          const ele = menu[index];
          let cur = null;
          // 系统对象+线索特殊处理
          if (ele.type == '10' && objectRoleEnum[ele.business] == firstRole) {
            // 线索路由需要特殊处理
            if (firstRole === 'clue' || firstRole === 'cluePool') {
              const clueRouter = cloneRouters.find((el) => el.name === 'leads');
              if (clueRouter?.children) {
                cur = clueRouter?.children.find((el) => el.meta.roles === firstRole);
              }
            } else {
              cur = cloneRouters.find((el) => el.meta.roles === objectRoleEnum[ele.business]);
            }
          }
          // 自定义对象
          if (ele.type == '20' && `${ele.business}` == firstRole) {
            const custom = cloneRouters.find((el) => el.name === 'custom')?.children || null;
            if (custom) {
              cur = custom.find((el) => el.meta.roles === firstRole) || null;
            }
          }
          // 系统菜单
          if (ele.type == '30' && ele.business == firstRole) {
            cur = cloneRouters.find((el) => el.meta.roles === firstRole);
          }
          if (cur) {
            menuSort = cur;
            break;
          }
        }
      }
      console.log(151777, cloneRouters, _routers, menuSort);
      if (menuSort) return menuSort;
      while (cloneRouters.length) {
        const firstElement = cloneRouters.shift();
        // console.log(
        //   37777,
        //   17,
        //   firstElement,
        //   role?.find((el) => el == firstElement?.meta?.roles),
        //   !firstElement.meta?.roles,
        //   firstElement.name
        // );
        // 如果一级没有roles，有子级，则去子级找一下
        if (!firstElement.meta?.roles && firstElement?.children?.length) {
          const sub = firstElement?.children.find((el) => role?.find((ele) => ele === el?.meta?.roles));
          if (sub) {
            return { name: sub.name };
          }
        }
        if (role?.find((el) => el == firstElement?.meta?.roles)) return { name: firstElement.name };
        if (firstElement?.children) {
          cloneRouters.push(...firstElement.children);
        }
      }
      return null;
    }
    // You can add any rules you want
  };
}
